<template lang="pug">
  .container.container_mobile
    .loader(v-if="!dataLoaded")
    .grid.grid_h-center.grid_v-margins(v-show="dataLoaded")
      ClubLeaders(
        class="grid__col grid__col_xl-20"
        v-if="club"
        v-show="club.membersCount"
        :sportTypes="club.sportTypeIds"
        @loaded="(e) => { leadersLoaded = e }"
      )
      .grid__col.grid__col_lg-14.grid__col_xl-12(v-if="dataLoaded")
        .grid.grid_v-margins
          .grid__col(v-if="clubAchievements.length")
            .block.block_wide
              .block__item.block__intro
                .block__intro-item.block__intro-item_md
                  h2 Достижения
                .block__intro-item(v-for="item in clubAchievements")
                  .achievment
                    .achievment__img
                      img(:src="medalImg(item.Position)" width="40" alt="3")
                    .achievment__info
                      .achievment__info-item.achievment__title {{ item.Position }} место • {{ item.NominationName }} <br><a class="link" :href="$getEnvVar('VUE_APP_CHAMPS_URL') + 'Championship/' + (item.ChampionshipCode || item.ChampionshipId)" target="_blank" rel="noopener noreferrer">{{ item.ChampionshipName }}</a>
                      .achievment__info-item.achievment__date: .text-sm
                        | {{ $moment(item.Date).format(`DD [${getShortMonth(item.Date)}] YYYY`) }}
          .grid__col
            .block.block_wide
              .block__item.block__intro
                .block__intro-item.block__intro-item_md
                  h2 О клубе
                .block__intro-item.text-content
                  span(
                    v-html="club.description"
                  )
              .block__item.block__body(v-if="club.sportTypeIds.length && sportTypesFilterValues.length")
                .block__body-item
                  h3.heading-line
                    span.heading-line__text Спортивная специализация
                .block__body-item
                  span(
                    v-for="(disciplineId, i) in club.sportTypeIds"
                    v-show="sportTypesFilterValuesObj[disciplineId]"
                    :key="disciplineId"
                  )
                    template(v-if="i !== 0") &nbsp;•
                      |
                      |
                    | {{ sportTypesFilterValuesObj[disciplineId] }}
              .block__item.block__body(v-if="hasMap || locationInfo")
                .block__body-item
                  h3.heading-line
                    span.heading-line__text Место
                .block__body-item
                  .club-location-map(v-show="hasMap")#locationMap
                  div(v-html="locationInfo")
              .block__item.block__body(v-if="club.manager")
                .block__body-item
                  h3.heading-line
                    span.heading-line__text Контакты
                .block__body-item
                  UserCard(
                    :name="club.manager.fullName"
                    :avatar="getCroppedImg(club.manager.avatarLargeUrl, [116])"
                    details="Владелец клуба"
                    :link="managerLink"
                  )
                    template(v-slot:actions)
                      a.button.button_secondary(
                        v-if="club.manager.email"
                        :href="`mailto:${club.manager.email}`"
                      )
                        span.button__text Написать
      .grid__col.grid__col_lg-10.grid__col_xl-8(
        v-if="dataLoaded"
        v-show="showRightColumn"
      )
        .grid.grid_v-margins
          .grid__col(v-show="showStarts")
            .block.block_wide
              .block__item.block__intro
                .block__intro-item.block__intro-item_md
                  h2 Чемпионаты
                    |
                    |
                    sup.color-muted: b {{ clubStartsCount }}
                .block__intro-item.block__intro-item_md
                  .grid.grid_gutters-sm.grid_v-margins
                    .grid__col.grid__col_12.grid__col_sm-8.grid__col_lg-12(v-if="clubStartsExternalCount > 0")
                      MetricsItem(
                        class="metric_hover"
                        name="между клубами",
                        :value="clubStartsExternalCount"
                        @click="goToChamps(2)"
                      )
                    .grid__col.grid__col_12.grid__col_sm-8.grid__col_lg-12(v-if="clubStartsInternalCount > 0")
                      MetricsItem(
                        class="metric_hover"
                        name="внутри клуба",
                        :value="clubStartsInternalCount"
                        @click="goToChamps(1)"
                      )
                .block__intro-item.block__intro-item_md(v-if="clubStartsItems.length")
                  .events
                    .events__title: b Ближайшие старты:
                    .events__item(v-for="item in clubStartsItems")
                      .event
                        .event__title: a.link(
                          :href="$getEnvVar('VUE_APP_EVENT_URL') + (item.Code || item.Id)"
                          target="_blank"
                          v-html="item.Name"
                        )
                        .text-sm {{ $moment(item.StartDate).format(`DD [${getShortMonth(item.StartDate)}] YYYY`) }}
          .grid__col(v-show="showMembers")
            .block.block_wide
              .block__item.block__intro
                .block__intro-item.block__intro-item_md
                  router-link.link.link_inherit(
                    :to="{ name: 'ClubMembers', hash: '#clubTabs' }"
                  )
                    h2 Участники
                      |
                      |
                      sup.color-muted: b {{ club.membersCount }}
                .block__intro-item
                  .members(v-if="clubMembers")
                    router-link.members__item.members__item_more(
                      v-if="membersPreview.length > 7"
                      :to="{ name: 'ClubMembers', hash: '#clubTabs' }"
                    )
                      Avatar(
                        username=""
                        :size="36"
                      )
                      icon.members__item-more(icon-name="more-horizontal")
                    .members__item(
                      v-for="(member, i) in membersPreview"
                      :key="member.id"
                    )
                      Avatar(
                        :username="member.fullName"
                        :img="member.avatarSmallUrl"
                        :size="36"
                      )
                  .members(v-else)
                    .members__item(v-for="i in (club.membersCount < 10 ? club.membersCount : 9)")
                      Skeleton(:circle="true" width="36px" height="36px")
          .grid__col(v-show="showActivities")
            .block.block_wide
              .block__item.block__intro
                .block__intro-item.block__intro-item_md
                  h2 Тренировки
                    |
                    |
                    sup.color-muted: b {{ clubActivitiesCount }}
                .block__intro-item
                  .training-chart
                    .training-chart__canvas#trainingChart
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { Skeleton } from 'vue-loading-skeleton'
import Avatar from '@/components/Avatar.vue'
import UserCard from '@/components/UserCard'
import MetricsItem from '@/components/MetricsItem'
import ClubLeaders from './includes/ClubLeaders'
import { disciplinesMixin } from '@/assets/js/mixins'
import { getCroppedImg, getShortMonth } from '@/assets/js/helpers'
import echarts from 'echarts/index.simple'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import { map, clone } from 'lodash'
import L from 'leaflet'
import { scrollToId } from '@/assets/js/animation'

let innerRoute = false

export default {
  name: 'ClubOverview',
  components: {
    Skeleton,
    Avatar,
    UserCard,
    MetricsItem,
    ClubLeaders
  },
  mixins: [disciplinesMixin],
  props: {
    club: Object,
    clubId: String
  },
  data () {
    return {
      leadersLoaded: null
    }
  },
  computed: {
    ...mapState('club', [
      'clubMembers',
      'clubAchievements',
      'clubStartsItems',
      'clubStartsCount',
      'clubStartsInternalCount',
      'clubStartsExternalCount',
      'clubActivities',
      'clubActivitiesCount',
      'membersUpdateTrigger'
    ]),
    ...mapGetters('clubs', [
      'sportTypesFilterValues',
      'sportTypesFilterValuesObj'
    ]),
    idClub () {
      return this.$route.params.id || this.$getTenantIdClub()
    },
    dataLoaded () {
      return !!(
        this.club &&
        typeof this.leadersLoaded === 'boolean' &&
        this.clubActivities &&
        this.clubAchievements &&
        this.clubStartsItems
      )
    },
    showRightColumn () {
      return this.dataLoaded && (this.showMembers || this.showActivities || this.showStarts)
    },
    showActivities () {
      return this.clubActivitiesCount
    },
    showMembers () {
      return this.club.membersCount
    },
    showStarts () {
      return this.clubStartsCount > 0
    },
    membersPreview () {
      const result = clone(this.clubMembers)
      result.splice(8)
      result.reverse()
      return result
    },
    locationInfo () {
      if (!this.club) {
        return ''
      }
      let result = this.club.address || ''
      if (this.club.isOnline) {
        result += result ? ' • ' : ''
        result += 'Онлайн клуб'
      }
      return result
    },
    hasMap () {
      return this.club.latitude && this.club.longitude
    },
    managerLink () {
      if (!this.club || !this.club.manager) {
        return null
      }
      const url = '' + this.club.manager.profileUrl
      const index = url.indexOf('?id=')

      if (index === -1) {
        return null
      }

      const id = url.slice(index)
      return this.$getEnvVar('VUE_APP_RR_URL') + 'profile' + id
    }
  },
  methods: {
    ...mapActions('club', [
      'getClubMembers',
      'getClubActivities',
      'getClubAchievements'
    ]),
    getCroppedImg,
    getShortMonth,
    medalImg (position) {
      return require('@/assets/img/icons/' + position + '-place-medal-simple.svg')
    },
    createMap () {
      if (!this.hasMap) {
        return
      }
      const location = new L.LatLng(this.club.latitude, this.club.longitude)
      const map = L.map('locationMap').setView(location, 13)

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        accessToken: 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map)

      L.marker(location).addTo(map)
    },
    createTrainingChart () {
      if (!this.clubActivitiesCount) {
        return
      }
      const values = map(this.clubActivities, item => {
        const info = this.disciplinesObj[item.sportType] || {}
        return {
          name: info.name || null,
          value: item.activitiesCount,
          itemStyle: {
            color: info.color || null
          }
        }
      })

      const options = {
        textStyle: {
          fontFamily: 'inherit'
        },
        tooltip: {
          backgroundColor: '#2B2B2B',
          padding: [8, 12],
          textStyle: {
            fontSize: 14,
            lineHeight: 20,
            color: '#FFFFFF'
          },
          formatter (params) {
            const text = `<span><b>${params.name}</b>: ${params.percent}%</span>`
            return params.marker + text
          }
        },
        legend: {
          width: '50%',
          top: 'middle'
        },
        series: [{
          name: 'Тренировки',
          type: 'pie',
          radius: ['60%', '90%'],
          label: {
            show: false
          },
          data: values
        }]
      }
      const chart = echarts.init(document.getElementById('trainingChart'), null, {
        renderer: 'svg'
      })
      chart.setOption(options)
      window.addEventListener('resize', chart.resize)
    },
    goToChamps (type) {
      if (type !== 1 && type !== 2) {
        return
      }

      this.$router.push({
        name: 'ClubChamps',
        query: { type: type },
        hash: '#clubTabs'
      })
    }
  },
  watch: {
    dataLoaded: {
      handler (val) {
        if (!val) {
          return
        }
        this.getClubMembers({
          code: this.idClub,
          offset: 0,
          count: 9
        })
        this.$nextTick(() => {
          this.createTrainingChart()
          this.createMap()
          if (innerRoute) {
            scrollToId('clubTabs', undefined, 0)
          }
        })
      },
      immediate: true
    },
    membersUpdateTrigger () {
      this.getClubMembers({
        code: this.idClub,
        offset: 0,
        count: 9
      })
      this.getClubActivities(this.idClub)
    },
    clubActivities (val) {
      if (val && this.dataLoaded) {
        this.$nextTick(() => {
          setTimeout(this.createTrainingChart(), 10)
        })
      }
    },
    club: {
      handler (val) {
        if (!val) {
          return
        }
        this.getClubAchievements({ clubId: val.id })
      },
      immediate: true
    }
  },
  beforeRouteEnter (to, from, next) {
    innerRoute = to.hash && from.params.id === to.params.id
    next()
  }
}
</script>

<style lang="scss" scoped>
  .club-location-map {
    height: 140px;
    margin-bottom: 16px;
  }

  .training-chart {
    width: 100%;
    max-width: 272px;
    margin: 0 auto;
    position: relative;

    &::before {
      content: "";
      display: block;
      width: 100%;
      padding-top: 100%;
    }

    &__canvas {
      position: absolute;
      top: 0;
      left: 0;
      width: 100% + (32/290*100%);
      height: 100% + (32/290*100%);
      margin: -16/290*100%;
    }
  }

  .members {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: flex-end;

    &__item {
      flex: 0 0 auto;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid #ffffff;
      position: relative;
      margin-left: -8px;
      text-decoration: none;
      z-index: 1;

      &:last-child {
        margin-left: 0;
      }

      &_more {

        &::after {
          content: "";
          position: absolute;
          background: map_get($color-neutral-black, 65);
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }

    &__item-more {
      display: none;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 18 / 36 * 100%;
      height: 18 / 36 * 100%;
      color: $color-white;
      transform: translate(-50%, -50%);
      z-index: 1;

      .members__item_more & {
        display: block;
      }
    }
  }

  .events {

    &__title {
      margin-bottom: 12px;
    }

    &__item {
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .event {

    &__title {
      margin-bottom: 4px;
    }
  }

  .achievment {
    display: flex;
    align-items: center;

    &__img {
      flex: 0 0 auto;
      margin-right: 16px;

      img {
        display: block;
      }
    }

    &__info {
      flex-grow: 1;
      min-width: 0;
      margin: 0 -10px -4px;

      @media (min-width: breakpoint(sm)) {
        display: flex;
        align-items: center;
      }
    }

    &__info-item {
      padding: 0 10px;
      margin-bottom: 4px;
      max-width: 100%;
    }

    &__title {
      font-weight: $font-weight-semibold;
      flex: 1 1 100%;
      min-width: 0;
    }

    &__date {
      flex: 0 0 auto;
    }
  }
</style>
